import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "header-panel" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "mt-6"
};
const _hoisted_4 = {
    key: 1,
    class: "mt-6"
};
const _hoisted_5 = {
    key: 2,
    class: "centered"
};
import { ref, onMounted } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useAppState } from '@/composables/useAppState';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BiggestDiscountsVouchersPage',
    setup(__props) {
        useAuth();
        const state = useAppState();
        const { getCustomer } = useCustomer();
        const { getRecommendedVouchers, addCustomerFavouriteDiscount, removeCustomerFavouriteDiscount } = useVouchers();
        const loading = ref(true);
        const biggestDiscounts6Months = ref(null);
        const formatter = state.formatter;
        function onLoad() {
            getCustomer();
            loadAvailable();
        }
        function loadAvailable() {
            getRecommendedVouchers(-180, (r) => {
                biggestDiscounts6Months.value = topDiscounts(r);
            });
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        function topDiscounts(vouchers) {
            const top = vouchers.sort((a, b) => {
                return (b.saving || 0) - (a.saving || 0);
            });
            return top.slice(0, 30);
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Top Savings" }),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_row, { class: "content-row" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "v-col-8" }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createElementVNode("h1", { class: "title" }, "Biggest Discounts", -1)
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { class: "v-col-4 voucher-count" }, {
                                default: _withCtx(() => [
                                    (biggestDiscounts6Months.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(biggestDiscounts6Months.value.length) + " Vouchers", 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                (biggestDiscounts6Months.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(VoucherList, {
                            showAll: true,
                            vouchers: biggestDiscounts6Months.value,
                            search: false,
                            showSaving: false,
                            showFavourites: true,
                            onFavouriteToggled: _cache[0] || (_cache[0] = (v) => { favouriteToggled(v); }),
                            formatter: _unref(formatter)
                        }, null, 8, ["vouchers", "formatter"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                            return _createElementVNode("div", {
                                key: i,
                                class: "mb-2"
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line" })
                            ]);
                        }), 64))
                    ])),
                (!loading.value && biggestDiscounts6Months.value.length == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, " No vouchers available at this time. "))
                    : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
